import Header from "components/layout/Header";
import { Col, Typography } from "antd";
import Table from "components/data/Table";
import { FormattedMessage } from "react-intl";
import ButtonLink from "components/common/ButtonLink";
import { ROUTE_PATHS } from "const/paths";

import { useEventColumns, useEventList } from "./hooks";

const EventList = () => {
  const { dataSource, loading, pagination, onChange } = useEventList({
    options: { excludeRecurringEvents: true },
  });
  const { columns } = useEventColumns();

  return (
    <>
      <Header>
        <Col>
          <Typography.Title>
            <FormattedMessage defaultMessage="Events" />
          </Typography.Title>
        </Col>
        <Col>
          <ButtonLink type="primary" block to={ROUTE_PATHS.Events}>
            <FormattedMessage defaultMessage="Create new event" />
          </ButtonLink>
        </Col>
      </Header>
      <Table
        rowKey="id"
        {...{ dataSource, pagination, columns, loading, onChange }}
      />
    </>
  );
};

export default EventList;
